import React, { useContext } from "react";
import { observer } from "mobx-react";
import classNames from "classnames";

import OfferIcon from "@components/icons/Offer";
import { ChannelResourceTypeDto } from "@api-types/chat";
import { LookupContext } from "@gp/components";
import { SportOffer, TournamentOffer } from "@gp/offer";

import { TournamentHeaderBettingTypeColumns } from "./header-betting-type-columns/TournamentHeaderBettingTypeColumns";
import {
	ChatButton,
	TournamentStatisticsButton,
} from "@features/offer/desktop/buttons";
import { FavoritesIcon } from "./FavoritesIcon";

export default observer(function LiveTournamentHeader({
	categoryId,
	hidden,
	setHidden,
	sport,
	tournamentId,
	isAdditionalOfferVisible,
}: {
	sport: SportOffer;
	categoryId: string;
	tournamentId: string;
	setHidden: (value: boolean) => void;
	hidden: boolean;
	isAdditionalOfferVisible?: boolean;
}) {
	const { tournaments, categories } = useContext(LookupContext);
	const category = categories.get(categoryId);
	const tournament = tournaments.get(tournamentId) as TournamentOffer;

	const headerClasses = classNames(
		"offer__head offer--live__head offer--live__tournament__header",
		{
			"is-collapsed": hidden,
			"is-expanded": !hidden,
		}
	);

	const tournamentIconClasses = classNames("offer__icon offer__icon--xmed", {
		"u-mar--right--xtny": isAdditionalOfferVisible,
	});

	const toggleBtnClasses = classNames(
		"offer__head__data offer__toggle offer--live__tournament__toggle",
		{
			"offer__toggle--sml": isAdditionalOfferVisible,
			"is-expanded": !hidden,
			"is-collapsed": hidden,
		}
	);

	const toggleIconClasses = classNames(
		"offer__toggle__icon u-icon u-icon--tny",
		{
			"u-icon--caret--down": !hidden,
			"u-icon--caret--right": hidden,
		}
	);

	if (!category || !tournament) {
		return null;
	}

	return (
		<div className={headerClasses}>
			<div className="offer__head__row">
				<div
					className="offer__head__data offer__title"
					title={`${category.name} - ${tournament.name}`}
				>
					<div className="offer--live__tournament__fav">
						<FavoritesIcon tournament={tournament} sport={sport} />
					</div>

					<div
						className={classNames("offer__title__wrapper", {
							"offer__title--tournament": !sport.isOutright,
						})}
					>
						<div className="offer__name offer__name--tournament">
							<span className={tournamentIconClasses}>
								<OfferIcon
									type="tournament"
									sport={sport.abrv}
									category={category.abrv}
									tournament={tournament.abrv}
									className="offer__icon__primary u-icon u-icon--xmed"
								/>
							</span>

							<span className="offer__name__clip">
								{category.name} - {tournament.name}
							</span>
						</div>

						{!isAdditionalOfferVisible ? (
							<div className="offer__head__actions u-padd--reset">
								<TournamentStatisticsButton
									tournament={tournament}
									isAdditionalOfferVisible={
										isAdditionalOfferVisible
									}
								/>

								<ChatButton
									channelType={ChannelResourceTypeDto.SPORT}
									resourceId={sport.id}
									sportAbrv={sport.abrv}
									isInTournamentHeader
								/>
							</div>
						) : null}
					</div>
				</div>
				<TournamentHeaderBettingTypeColumns />
				<div className={toggleBtnClasses}>
					<button
						type="button"
						className="offer__toggle__btn btn btn--square btn--square--xsml btn--ghost"
						onClick={() => setHidden(!hidden)}
					>
						<i className={toggleIconClasses} />
					</button>
				</div>
			</div>
		</div>
	);
});
